import React from 'react';
import styled from 'styled-components';
import { Typography } from '../Typography';

export const MenuListLabel = ({ children }: React.PropsWithChildren<{}>) => (
  <StyledTypography>{children}</StyledTypography>
);

const StyledTypography = styled(Typography).attrs(() => ({
  variant: 'hint'
}))`
  padding: ${({ theme }) => theme.spacingSize.l};
`;
